export class FieldFilters {
  fieldQuery?: string;
  selectedBatteries: any[];
  selectedTanks: any[];
  runTicketQuery?: string;
}

export class ReportFilters {
  groupID?: number;
  reportQuery?: string;
}
